module.exports = __webpack_public_path__ + "static/img/SZ.3a9351a4.png";